import { Stack, Typography, useTheme } from "@mui/material";
import CountUp from "../../../components/animation/countUp/countUp";

const SummaryBox = ({
    value,
    description,
    suffixValue="",
    suffixIcon,
    alignItems='center',
    direction='column',
    stopCountUp=false,
    hidePrefixZero=false,
    hightLight=false
}) => {
    const theme = useTheme();

    return (
        <>
            <Stack
                direction={direction}
                justifyContent='center'
                alignItems={alignItems}
                py={6}
                px={5}
                spacing={1}
                sx={{
                    backgroundColor: hightLight ? theme.palette.text.primary : 'transparent',
                    height: '100%'
                }}
            >
                <Typography
                    fontWeight={700}
                    fontSize={{xs: 24, md: 32, lg: 50}}
                    textAlign='left'
                    color={hightLight ? theme.palette.background.default : theme.palette.primary.contrastText}
                >
                    {
                        !hidePrefixZero && Number.parseInt(value) < 10
                        ?
                        <span>0</span>
                        :
                        <></>
                    }

                    {
                        stopCountUp
                        ?
                        value
                        :
                        <CountUp
                            from={0}
                            to={Number.parseInt(value)}
                            separator="+"
                            direction="up"
                            duration={1}
                            className="count-up-text"
                        />
                    }   

                    <span>{suffixValue}</span>

                    <span> {suffixIcon}</span>
                </Typography>

                <Typography
                    fontWeight={600}
                    fontSize={{xs: 12, md: 12, lg: 16}}
                    textAlign={alignItems}
                    lineHeight={1.25}
                    color={hightLight ? theme.palette.background.default : theme.palette.primary.contrastText}
                >
                    {description}
                </Typography>
            </Stack>    
        </>
    );
}

export default SummaryBox;